import sanitizeHtml from "sanitize-html";

export const stringUtil = {
  prepareDangerousHTML: (html) => {
    if (typeof html !== "string" || html.trim() === "") return "";

    return sanitizeHtml(html, {
      disallowedTagsMode: "discard",
      allowedTags: [
        "strong",
        "em",
        "s",
        "sub",
        "sup",
        "a",
        "p",
        "ul",
        "ol",
        "li",
      ],
      allowedAttributes: {
        a: ["href", "target", "rel"],
      },
      allowedSchemesByTag: {
        a: ["https"],
      },
    });
  },
};
